import React, { createContext, useContext, useState, useEffect } from 'react';

const ViewpointContext = createContext();

export const VIEWPOINTS = {
  MOBILE: 'mobile',          // Real mobile devices
  TABLET: 'tablet',          // Real tablets
  NARROW: 'narrow',          // Narrow desktop window (<1024px)
  DESKTOP: 'desktop',        // Standard desktop (1024-1440px)
  WIDE: 'wide',             // Wide desktop (>1440px)
};

const isMobileDevice = () => {
  const ua = window.navigator.userAgent;
  return /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(ua) && !/tablet|ipad/i.test(ua);
};

const isTabletDevice = () => {
  const ua = window.navigator.userAgent;
  return /ipad|tablet/i.test(ua);
};

export const ViewpointProvider = ({ children }) => {
  const [currentViewpoint, setCurrentViewpoint] = useState(VIEWPOINTS.DESKTOP);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      let newViewpoint;

      // First check if it's actually a mobile/tablet device
      if (isMobileDevice()) {
        newViewpoint = VIEWPOINTS.MOBILE;
      } else if (isTabletDevice()) {
        newViewpoint = VIEWPOINTS.TABLET;
      } else {
        // For desktop browsers, use size-based detection
        if (width >= 1440) {
          newViewpoint = VIEWPOINTS.WIDE;
        } else if (width >= 1024) {
          newViewpoint = VIEWPOINTS.DESKTOP;
        } else {
          // Any desktop window smaller than 1024px
          newViewpoint = VIEWPOINTS.NARROW;
        }
      }

      if (newViewpoint !== currentViewpoint) {
        setCurrentViewpoint(newViewpoint);
      }
    };

    window.addEventListener('resize', handleResize);
    // Initial detection
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, [currentViewpoint]);

  return (
    <ViewpointContext.Provider value={{ currentViewpoint }}>
      {children}
    </ViewpointContext.Provider>
  );
};

export const useViewpoint = () => {
  const context = useContext(ViewpointContext);
  if (!context) {
    throw new Error('useViewpoint must be used within a ViewpointProvider');
  }
  return context;
}; 